/* eslint-disable react/prop-types */
import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AiFillEyeInvisible } from "react-icons/ai";
import { BsEyeFill } from "react-icons/bs";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  inputWrap1: {
    width: "100%",
    minWidth: "100%",
  },
  inputWrap2: {
    width: "100%",
    minWidth: "100%",
    position: "relative",
  },
  input: {
    "& .MuiFormHelperText-root": {
      fontWeight: "bold",
    },
  },
  eyeIcon: {
    position: "absolute",
    right: "8px",
    display: "block",
    margin: "auto",
    top: "calc(1.4375rem / 1.5)",
    fontSize: "1.5rem",
    color: `${
      theme.palette?.mode !== "dark" ? "#282828b2" : "#fff"
    } !important`,
    cursor: "pointer",
  },
}));

export default function CustomTextField(props) {
  const classes = useStyles();
  const [type, setType] = useState(props.type);
  const [active, setActive] = useState(true);
  if (props.type === "password") {
    return (
      <div className={classes.inputWrap1}>
        <div className={classes.inputWrap2}>
          <TextField
            {...props}
            type={type !== "password" ? type : active ? "password" : "text"}
          />
          {type === "password" &&
            (active ? (
              <BsEyeFill
                onClick={() => setActive((prev) => !prev)}
                className={classes.eyeIcon}
              />
            ) : (
              <AiFillEyeInvisible
                onClick={() => setActive((prev) => !prev)}
                className={classes.eyeIcon}
              />
            ))}
        </div>
      </div>
    );
  }

  return <TextField {...props} />;
}
